import adjustHeader from './adjustHeader';
import toggleMobileNavigation from './toggleMobileNavigation';

const init = (): void => {
  adjustHeader();
  toggleMobileNavigation();
};

export default { init };
